// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"181":"01019ec6","925":"6d0f0fd5","981":"6575dda6","992":"4bb10da3"}[chunkId] + ".chunk.css";
};